import { Outlet } from "react-router";
import ScrollManager from "./ScrollManager";

/**
 * Outermost layout. Handles scroll behavior globally. Page-fade + persistent
 * navbar live in SiteLayout (public routes only); portal/admin routes render
 * plain so their own chrome (e.g. the admin sidebar) doesn't blink.
 */
export default function RootLayout() {
  return (
    <>
      <ScrollManager />
      <Outlet />
    </>
  );
}
